"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRemoveHandler = void 0;
var _analyticsData = require("@ori/analytics-data");
var _logger = require("@ori/logger");
var _react = require("react");
var _utils = require("../../utils");
const useRemoveHandler = ({
  itemCode,
  lineNumber,
  outOfStock,
  requestedQuantity
}) => {
  const logger = (0, _logger.useLogger)('useRemoveHandler');
  const removeItemHandler = (0, _react.useCallback)(async () => {
    const previousQuantity = requestedQuantity;
    try {
      await (0, _utils.removeBasketItem)({
        itemCode,
        lineNumber,
        outOfStock,
        placement: _analyticsData.Placement.Minibag,
        previousQuantity
      });
    } catch (error) {
      logger.error(error);
    }
  }, [itemCode, lineNumber, logger, outOfStock, requestedQuantity]);
  return {
    removeItemHandler
  };
};
exports.useRemoveHandler = useRemoveHandler;